<template>
  <div>

    <ui-form>
      <div class="sm:overflow-hidden">
        <div class="bg-white space-y-6">
          <div>
            <h3 class="text-lg leading-6 font-medium text-gray-900">Для координатора</h3>
            <p class="mt-1 text-sm text-gray-500">
              Информация, которая предназначена для координатора
            </p>
          </div>
          <div class="grid grid-cols-3 gap-6">

            <ui-form-item label="Комментарий" required class="col-span-3">
              <ui-form-editor :holder="`mentor`"/>
            </ui-form-item>


            <!--            <div class="col-span-3">
                          <ui-form-item label="Файлы отчетов"
                                        text-help="Шаблоны для формирования отчетов по мероприятию для координатора">

                            <ul class="border border-gray-200 rounded-md divide-y divide-gray-200">
                              <li class="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                                <div class="w-0 flex-1 flex items-center">
                                  <svg class="flex-shrink-0 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg"
                                       viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                    <path fill-rule="evenodd"
                                          d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z"
                                          clip-rule="evenodd"></path>
                                  </svg>
                                  <span class="ml-2 flex-1 w-0 truncate">
                              Баллы участников.pdf
                            </span>
                                </div>
                                <div class="ml-4 flex-shrink-0 flex space-x-4">
                                  <button type="button"
                                          class="bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                    Обновить
                                  </button>
                                  <span class="text-gray-300" aria-hidden="true">|</span>
                                  <button type="button"
                                          class="bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                    Удалить
                                  </button>
                                </div>
                              </li>

                              <li class="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                                <div class="w-0 flex-1 flex items-center">
                                  <svg class="flex-shrink-0 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg"
                                       viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                    <path fill-rule="evenodd"
                                          d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z"
                                          clip-rule="evenodd"></path>
                                  </svg>
                                  <span class="ml-2 flex-1 w-0 truncate">
                              Таблица проверки ответов.pdf
                            </span>
                                </div>
                                <div class="ml-4 flex-shrink-0 flex space-x-4">
                                  <button type="button"
                                          class="bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                    Обновить
                                  </button>
                                  <span class="text-gray-300" aria-hidden="true">|</span>
                                  <button type="button"
                                          class="bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                    Удалить
                                  </button>
                                </div>
                              </li>


                            </ul>


                          </ui-form-item>
                          <div class="mt-5 text-sm text-center">
                            <span class="link">Добавить отчета</span>
                          </div>

                        </div>-->


            <div class="col-span-3">

              <div class="divide-y divide-gray-200 pt-8 space-y-6">
                <div>
                  <h3 class="text-lg leading-6 font-medium text-gray-900">
                    Уведомления
                  </h3>
                  <p class="mt-1 max-w-2xl text-sm text-gray-500">
                    Напоминания, которые будут отправляться координатору
                  </p>
                </div>

                <ui-form class="ml-4 space-y-4">
                  <ui-form-item label="Нет оплаты" :child-label="true"
                                text-help="Отсутствия оплаты (за день до начала мероприятия)">
                    <ui-form-checkbox/>
                  </ui-form-item>
                  <ui-form-item label="Нет работы" :child-label="true"
                                text-help="Отсутствуют работы участников (за два для до окончания мероприятия)">
                    <ui-form-checkbox/>
                  </ui-form-item>
                  <ui-form-item label="Об итогах" :child-label="true"
                                text-help="Сводная таблица по итогам (после завершения мероприятия)">
                    <ui-form-checkbox/>
                  </ui-form-item>
                </ui-form>
              </div>

            </div>


          </div>


          <div class=" text-right ">
            <ui-button>Сохранить</ui-button>
          </div>
        </div>

      </div>
    </ui-form>

  </div>
</template>

<script>
import UiButton from "@/components/ui/button/UiButton";

import UiFormItem from "@/components/ui/form/UiFormItem";
import UiFormEditor from "@/components/ui/form/editor/UiFormEditor";
import UiForm from "@/components/ui/form/UiForm";
import UiFormCheckbox from "@/components/ui/form/UiFormCheckbox";

export default {
  name: "EventEditMentor",
  components: {UiFormCheckbox, UiForm, UiFormEditor, UiFormItem, UiButton,},
  data() {
    return {
      form: {
        name: '',
        date_start_reg: null,
        date_end: null,

      }
    }
  }
}
</script>

<style scoped>

</style>